<div class="result-html">
    <div class="result-heading" [innerHTML]="headingHtml"></div>
    <ng-content></ng-content>
    <div class="result-body" [innerHTML]="html"></div>
</div>
